import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { RowActions } from '../../../../../../components'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { useListFilters } from '../../core/ListFiltersProvider'
import { FaturaView } from '../../../faturas-list/core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  fatura: FaturaView
}

/** Ação única da linha: ver os atendimentos da fatura (na visão do responsável da instituição). */
export const FaturaResponsavelActionsCell: FC<IProps> = ({ fatura }) => {
  const { filters } = useListFilters()
  const { t } = useT()
  const navigate = useNavigate()

  const idEmpresa = filters.empresa?.value
  const { mesSigla, ano } = fatura.mesAno ?? {}

  const handleAtendimentos = () =>
    navigate(`/financeiro/faturas/atendimentos/${fatura.id}${idEmpresa ? `/${idEmpresa}` : ''}`)

  return (
    <RowActions
      itemName={mesSigla && ano ? `fatura de ${mesSigla}/${ano}` : `fatura ${fatura.id}`}
      primaryAction={{
        label: t('dropdown_item.visualizar_atendimentos'),
        onClick: handleAtendimentos,
        icon: IconPaths.Search,
      }}
    />
  )
}
